import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const userInfoSelector = (state: State) => state.userInfo.entities;
export const userInfoStatusSelector = (state: State) => state.userInfo.status;

export const userInfoLoadedSelector = isLoaded(userInfoStatusSelector);
export const userInfoRejectedSelector = isRejected(userInfoStatusSelector);
export const userInfoPendingSelector = isPending(userInfoStatusSelector);
export const shouldLoadUsersSelector = shouldLoad(userInfoStatusSelector);
